import { extractApiErrorMessage } from '@readcloud/fetch-wrapper';

/**
 * The browser fetch path resolves on 4xx/5xx, so thunks must reject
 * explicitly or reducers apply mutations the server refused. (The Tauri
 * path already throws HttpError inside the fetch wrapper before this runs.)
 */
export async function ensureOkResponse(response: Response): Promise<Response> {
  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(
      extractApiErrorMessage(body) ||
        `Request failed with status ${response.status}`
    );
  }
  return response;
}
